/**
 * BT-051 — Client API CRUD backend staging.
 */
import { backendFetch } from "./karateBackendApi.js";

function apiErrorMessage(err, ui) {
  const payload = err?.payload;
  if (payload?.messageFr && payload?.messageEn) {
    return ui?.locale === "en" ? payload.messageEn : payload.messageFr;
  }
  if (payload?.messageFr) return payload.messageFr;
  if (payload?.messageEn) return payload.messageEn;
  if (err?.status === 403) return ui?.backendCrud?.forbidden ?? "Accès refusé.";
  if (err?.status === 400) return ui?.backendCrud?.validationError ?? "Erreur de validation.";
  return ui?.backendCrud?.saveError ?? "Erreur lors de l'enregistrement.";
}

export { apiErrorMessage };

export async function apiCreateDojo(item) {
  return backendFetch("/api/v1/dojos", {
    method: "POST",
    body: JSON.stringify({
      id: item.id,
      nom: item.nom,
      ville: item.ville,
      adresse: item.adresse,
      telephone: item.telephone,
      courriel: item.courriel,
      sensei_id: item.sensei_id,
      statut: item.statut,
      demo: item.demo,
    }),
  });
}

export async function apiUpdateDojo(id, item) {
  return backendFetch(`/api/v1/dojos/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify({
      nom: item.nom,
      ville: item.ville,
      adresse: item.adresse,
      telephone: item.telephone,
      courriel: item.courriel,
      sensei_id: item.sensei_id,
      statut: item.statut,
      demo: item.demo,
    }),
  });
}

export async function apiDeactivateDojo(id) {
  return backendFetch(`/api/v1/dojos/${encodeURIComponent(id)}/status`, {
    method: "PATCH",
    body: JSON.stringify({ statut: "inactif" }),
  });
}

export async function apiCreateStudent(item) {
  return backendFetch("/api/v1/students", {
    method: "POST",
    body: JSON.stringify({
      id: item.id,
      prenom: item.prenom,
      nom: item.nom,
      dojo_id: item.dojo_id,
      groupe: item.groupe,
      ceinture: item.ceinture,
      statut: item.statut,
    }),
  });
}

export async function apiUpdateStudent(id, item) {
  return backendFetch(`/api/v1/students/${encodeURIComponent(id)}`, {
    method: "PATCH",
    body: JSON.stringify({
      prenom: item.prenom,
      nom: item.nom,
      dojo_id: item.dojo_id,
      groupe: item.groupe,
      ceinture: item.ceinture,
      statut: item.statut,
    }),
  });
}

export async function apiDeactivateStudent(id) {
  return backendFetch(`/api/v1/students/${encodeURIComponent(id)}/status`, {
    method: "PATCH",
    body: JSON.stringify({ statut: "inactif" }),
  });
}

export async function apiCreateRoleAssignment(item) {
  const role = item.titre?.toLowerCase().includes("sempai") ? "assistant" : "sensei";
  return backendFetch("/api/v1/role-assignments", {
    method: "POST",
    body: JSON.stringify({
      id: item.assignment_id || `ra-${item.id}`,
      person_id: item.id,
      nom: item.nom,
      role,
      dojo_id: item.dojo_id,
      titre: item.titre,
      courriel: item.courriel,
      telephone: item.telephone,
      statut: item.statut,
    }),
  });
}

export async function apiUpdateRoleAssignment(assignmentId, item) {
  const role = item.titre?.toLowerCase().includes("sempai") ? "assistant" : "sensei";
  return backendFetch(`/api/v1/role-assignments/${encodeURIComponent(assignmentId)}`, {
    method: "PATCH",
    body: JSON.stringify({
      nom: item.nom,
      role,
      dojo_id: item.dojo_id,
      titre: item.titre,
      courriel: item.courriel,
      telephone: item.telephone,
      statut: item.statut,
    }),
  });
}

export async function apiDeactivateRoleAssignment(assignmentId) {
  return backendFetch(`/api/v1/role-assignments/${encodeURIComponent(assignmentId)}/status`, {
    method: "PATCH",
    body: JSON.stringify({ statut: "inactif" }),
  });
}

export async function apiFetchPeople() {
  return backendFetch("/api/v1/people");
}

export async function apiFetchRoleAssignments() {
  return backendFetch("/api/v1/role-assignments");
}

export async function apiFetchParentStudentLinks() {
  return backendFetch("/api/v1/parent-student-links");
}

export async function apiCreateParent(item) {
  return backendFetch("/api/v1/parents", {
    method: "POST",
    body: JSON.stringify({
      id: item.id,
      nom: item.nom,
      courriel: item.courriel,
      telephone: item.telephone,
      statut: item.statut,
      demo: item.demo,
    }),
  });
}

export async function apiDeactivateParent(id) {
  return backendFetch(`/api/v1/parents/${encodeURIComponent(id)}/status`, {
    method: "PATCH",
    body: JSON.stringify({ statut: "inactif" }),
  });
}
